__turbopack_context__.v({
  "dot": "DotLine-module__nFRSeW__dot",
  "drawArea": "DotLine-module__nFRSeW__drawArea",
  "drawWrapper": "DotLine-module__nFRSeW__drawWrapper",
  "fadeIn": "DotLine-module__nFRSeW__fadeIn",
  "globalStyle": "DotLine-module__nFRSeW__globalStyle",
  "line": "DotLine-module__nFRSeW__line",
});
